import { getHostUrlByEnv } from '@/utils';

export const BUSINESS_URL = '/business';
export const CHROME_EXTENSION_URL =
  'https://chromewebstore.google.com/detail/notta-ai-meeting-notetake/kdelkaogljjcbjffjmahedaobfjineig?hl=en';
export const BIZ_TRIAL_URL = `${getHostUrlByEnv()}?from=official&subscribe_type=team&trial=1`;
export const PRO_TRIAL_URL = 'https://support.notta.ai/hc/ja/articles/17752924509211'

export const COMMON_LINKS = {
  business: BUSINESS_URL,
  chromeExtension: CHROME_EXTENSION_URL,
  bizTrial: BIZ_TRIAL_URL,
  proTrial: PRO_TRIAL_URL,
}